import shadowUrl from 'url:/src/img/leaflet-icons/marker-shadow.png'
// import blueUrl from 'url:/src/img/leaflet-icons/marker-icon-blue.png'
// import blue2xUrl from 'url:/src/img/leaflet-icons/marker-icon-blue-2x.png'
import redUrl from 'url:/src/img/leaflet-icons/marker-icon-red.png'
import red2xUrl from 'url:/src/img/leaflet-icons/marker-icon-red-2x.png'
import whiteUrl from 'url:/src/img/leaflet-icons/marker-icon-white.png'
import white2xUrl from 'url:/src/img/leaflet-icons/marker-icon-white-2x.png'

const CustomIcon = L.Icon.extend({
    options: {
        shadowUrl: shadowUrl,
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        tooltipAnchor: [16, -28],
        shadowSize: [41, 41]
    }
});

// export const blueIcon = new CustomIcon({iconUrl: blueUrl});
export const redMarkerIcon = new CustomIcon({iconUrl: redUrl, iconRetinaUrl: red2xUrl});
export const whiteMarkerIcon = new CustomIcon({iconUrl: whiteUrl, iconRetinaUrl: white2xUrl});